import React from "react";
import CategoriaBar from "./CategoriaBar";
import MidPageEmpresarial from "./MidPageEmpresarial"
import TopBar from "./TopBar";

export default function EmpresarialSite() {
    return (
        <div>
            <TopBar />
            <CategoriaBar />
            <MidPageEmpresarial />
        </div>
    )
}